import fetch from 'cross-fetch';
import ConfigurationAPI from './ConfigurationAPI';

class FacturasAPI extends ConfigurationAPI {
    get = async (id) => {
      const url = `${this.url}/list/TreebesFacturas?related_to=${id}`;
      try {
        const response = await fetch(url, this.credentials);
        const json = await response.json();
        return { ...json };
      } catch (getErr) {
        return {
          success: false,
          result: [],
          message: `Error al crear una dirección: ${getErr}`,
        };
      }
    }
}

export default FacturasAPI;
